module.exports = __webpack_public_path__ + "img/lithium.77b749c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/integrations/lithium.png
// module id = PRhi
// module chunks = 39 44